import { QuestionBlockRepeater, QuestionTaxResidenceBlock } from 'components/Questionnaires/blocks';

export function rcTaxResidencesBlock() {
  return {
    id: 'taxResidences',
    title: 'questionnaire.rc.taxResidences',
    component: QuestionBlockRepeater,
    isCollapsed: true,
    componentProps: {
      collapsible: true,
      optional: true
    },
    repeatBlock: {
      id: 'taxResidence',
      title: 'questionnaire.rc.taxResidence.additional',
      component: QuestionTaxResidenceBlock,
      componentProps: {
        reasonItems: 'questionnaire.rc.taxResidence.reasons',
        reasonOtherValue: '3',
        optional: true
      }
    },
    minSize: 1,
    maxSize: 2,
    addText: 'questionnaire.rc.taxResidences.addLabel',
    visible: true,
  };
}

export default rcTaxResidencesBlock;
